import React from "react";
import InvoicesPrint from "../AFReadyDisigen/InvoicesPrint";

export default function BillTemplate(props) {
    return (
        <div>
            <InvoicesPrint  typeInv={5} />
        </div>
    );
}

